import { PersonPage } from '../components/PersonPage';

export function Couple() {
  return (
    <PersonPage
      role="The Couple"
      name="Lynne & Andi"
      tagline="Across countries and cultures — home, not in a place, but in each other."
      bio="Lynne and Andi's story is one of love, growth, and building a life together across countries and cultures. From Malaysia to Australia, they have found home not just in a place, but in each other."
      interests={[]}
      hero="/people/couple-1.jpeg"
      gallery={[
        '/people/couple-2.jpeg',
        '/people/couple-3.jpeg',
        '/people/couple-4.jpeg',
        '/people/couple-5.jpeg',
      ]}
    />
  );
}
